import { doc, DocumentReference } from 'firebase/firestore';
import isEmpty from 'lodash/isEmpty';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { EZScorePreference, IRange, ISelectOption, IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';
import {
  IExclusiveDateOption,
  IInclusiveDateOption,
} from './dates/dateRangeProvider';

export interface IComparisonPopulationSetting {
  dateRangeType: IExclusiveDateOption | IInclusiveDateOption;
  dateRangeValues?: IRange;
  entity: ISelectOption;
  zScorePreference?: EZScorePreference;
}

/**
 * @description the default comparison population
 */
export const defaultComparisonPopulationSetting: IComparisonPopulationSetting =
  {
    dateRangeType: {
      label: 'All Time',
      value: 'all-time',
    },
    dateRangeValues: null,
    entity: {
      label: 'Self',
      value: 'self',
    },
    zScorePreference: EZScorePreference.Scaled,
  };

/**
 * @description observes the users comparison population settings
 */
export const comparisonPopulationSettingsProvider =
  (): Observable<IComparisonPopulationSetting> => {
    return authenticatedUserProvider().pipe(
      switchMap((user: IUser): Observable<IComparisonPopulationSetting> => {
        return docData(
          doc(
            user.services.firestore,
            `/userProfiles/${user.id}/settings/comparisonPopulation`
          ) as DocumentReference<IComparisonPopulationSetting>
        ).pipe(
          map(
            (
              setting: IComparisonPopulationSetting
            ): IComparisonPopulationSetting => {
              return !isEmpty(setting)
                ? setting
                : defaultComparisonPopulationSetting;
            }
          )
        );
      })
    );
  };
